import { useEffect } from 'react';
import LegalLayout from '../components/legal/LegalLayout.jsx';
import { setPageMetadata } from '../utils/seo.js';

const PRIVACY_SECTIONS = [
	{ id: 'resumen-rapido', label: 'Resumen rapido' },
	{ id: 'datos-recopilados', label: 'Datos que recopilamos' },
	{ id: 'uso-de-datos', label: 'Como usamos la informacion' },
	{ id: 'seguridad', label: 'Conservacion y seguridad' },
	{ id: 'derechos', label: 'Tus derechos' },
];

function PrivacyPage() {
	useEffect(() => {
		setPageMetadata({
			title: 'Politica de Privacidad | CodingFlash',
			description:
				'Conoce que datos recopila CodingFlash, como los usamos y como podes gestionar tus derechos sobre tu informacion personal.',
			path: '/privacidad',
		});
	}, []);

	return (
		<LegalLayout
			title='Politica de Privacidad'
			description='En CodingFlash cuidamos tus datos personales. Aca te contamos que informacion recopilamos, para que la usamos y como podes gestionar tus datos.'
			updatedAt='2026-02-19'
			sections={PRIVACY_SECTIONS}
		>
			<section
				id='resumen-rapido'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Resumen rapido
				</h2>
				<ul className='list-disc space-y-2.5 pl-5 text-sm leading-relaxed sm:text-base'>
					<li>Solo pedimos datos necesarios para responder y trabajar.</li>
					<li>No vendemos tus datos a terceros.</li>
					<li>Podes pedir acceso, correccion o eliminacion cuando quieras.</li>
				</ul>
			</section>

			<section
				id='datos-recopilados'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Datos que recopilamos
				</h2>
				<ul className='list-disc space-y-2.5 pl-5 text-sm leading-relaxed sm:text-base'>
					<li>Nombre y correo electronico enviados por formularios.</li>
					<li>Informacion que compartis de forma voluntaria en mensajes.</li>
					<li>Datos tecnicos anonimos para mejorar el sitio.</li>
				</ul>
			</section>

			<section
				id='uso-de-datos'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Como usamos la informacion
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Usamos estos datos para responder consultas, preparar propuestas,
					coordinar servicios y mejorar la experiencia del sitio.
				</p>
			</section>

			<section
				id='seguridad'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Conservacion y seguridad
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Conservamos la informacion solo durante el tiempo necesario para la
					finalidad declarada y aplicamos medidas razonables para evitar accesos
					no autorizados, perdida o uso indebido.
				</p>
			</section>

			<section
				id='derechos'
				className='rounded-xl border border-white/10 bg-white/[0.02] p-5 sm:p-6'
			>
				<h2 className='mb-3 text-lg font-semibold text-primary sm:text-xl'>
					Tus derechos
				</h2>
				<p className='text-sm leading-relaxed sm:text-base'>
					Podes solicitar acceso, actualizacion o eliminacion de tus datos en
					cualquier momento escribiendo a{' '}
					<a
						href='mailto:codingflash.agency@gmail.com'
						className='inline-block max-w-full break-words text-primary underline decoration-white/30 underline-offset-4 transition-colors hover:decoration-primary [overflow-wrap:anywhere]'
					>
						codingflash.agency@gmail.com
					</a>
					.
				</p>
			</section>
		</LegalLayout>
	);
}

export default PrivacyPage;
